module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-2"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "fullscreen"
    },
    model: {
      value: (_vm.isModalExportar),
      callback: function($$v) {
        _vm.isModalExportar = $$v
      },
      expression: "isModalExportar"
    }
  }, [(_vm.isModalExportar) ? _c('parametros-de-exportacion', {
    attrs: {
      "preview": "save",
      "tipo-predefinido": _vm.tipoArea,
      "tipoticket": _vm.tiposTicket[0]
    },
    on: {
      "close": _vm.closeDialogExportar
    }
  }) : _vm._e()], 1), _c('v-card', [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Tickets abiertos")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12"
  }, [_vm._v("Listado general de tickets activos")])], 1), (_vm.perfilUsuario === 'usuario' || _vm.perfilUsuario === 'usuario-contrato') ? _c('v-switch', {
    staticClass: "mx-4",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "label": "Cerrados"
    },
    on: {
      "change": function($event) {
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.isClosed),
      callback: function($$v) {
        _vm.isClosed = $$v
      },
      expression: "isClosed"
    }
  }) : _vm._e(), _c('v-menu', {
    attrs: {
      "offset-y": "offset-y",
      "close-on-content-click": false,
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mt-3",
          attrs: {
            "color": _vm.countFiltros ? 'primary' : 'background',
            "small": "small",
            "fab": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("filter_alt")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showFiltros),
      callback: function($$v) {
        _vm.showFiltros = $$v
      },
      expression: "showFiltros"
    }
  }, [_c('v-card', {
    attrs: {
      "width": "550"
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [(_vm.tipoArea !== 'sin atencion' && _vm.tipo === 'garantia') ? _c('div', [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('span', {
    staticClass: "font-size-12 grey--text"
  }, [_vm._v("Estados")])]), (_vm.showFiltros) ? _c('estados-ticket', {
    ref: "estados",
    staticClass: "mb-1",
    attrs: {
      "tipo": _vm.tipo,
      "show-clear": "show-clear",
      "codigo": _vm.estado
    },
    on: {
      "selected": _vm.selectEstado
    }
  }) : _vm._e()], 1) : _vm._e(), _c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Numero de ticket",
      "type": "number"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      },
      "blur": function($event) {
        return _vm.addCountFiltros()
      }
    },
    model: {
      value: (_vm.numero),
      callback: function($$v) {
        _vm.numero = $$v
      },
      expression: "numero"
    }
  }), _c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Desde la fecha",
      "type": "date"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      },
      "blur": function($event) {
        return _vm.addCountFiltros()
      }
    },
    model: {
      value: (_vm.desde),
      callback: function($$v) {
        _vm.desde = $$v
      },
      expression: "desde"
    }
  }), _c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Hasta la fecha",
      "type": "date"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      },
      "blur": function($event) {
        return _vm.addCountFiltros()
      }
    },
    model: {
      value: (_vm.hasta),
      callback: function($$v) {
        _vm.hasta = $$v
      },
      expression: "hasta"
    }
  }), (_vm.perfilUsuario !== 'usuario' && _vm.perfilUsuario !== 'usuario-contrato') ? _c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Codigo de Cliente - Interno/Sap",
      "type": "number"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      },
      "blur": function($event) {
        return _vm.addCountFiltros()
      }
    },
    model: {
      value: (_vm.codigoCliente),
      callback: function($$v) {
        _vm.codigoCliente = $$v
      },
      expression: "codigoCliente"
    }
  }) : _vm._e(), _c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Serie",
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      },
      "blur": function($event) {
        return _vm.addCountFiltros()
      }
    },
    model: {
      value: (_vm.serie),
      callback: function($$v) {
        _vm.serie = $$v
      },
      expression: "serie"
    }
  }), (_vm.tipo === 'garantia') ? _c('v-radio-group', {
    staticClass: "py-0",
    attrs: {
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.addCountFiltros()
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Zona garantia")])]
      },
      proxy: true
    }], null, false, 3922478954),
    model: {
      value: (_vm.zonaGarantia),
      callback: function($$v) {
        _vm.zonaGarantia = $$v
      },
      expression: "zonaGarantia"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "lima",
      "row": "row"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.zonaGarantia === 'lima'
          }
        }, [_vm._v("Lima")])]
      },
      proxy: true
    }], null, false, 1929651564)
  }), _c('v-radio', {
    attrs: {
      "value": "arequipa"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.zonaGarantia === 'arequipa'
          }
        }, [_vm._v("Arequipa")])]
      },
      proxy: true
    }], null, false, 3340764236)
  }), _c('v-radio', {
    attrs: {
      "value": "sin asignacion"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.zonaGarantia === 'sin asignacion'
          }
        }, [_vm._v("Sin asignación")])]
      },
      proxy: true
    }], null, false, 2373507216)
  })], 1) : _vm._e(), (_vm.tipo === 'garantia' && _vm.tipoDeArea === 'sin atencion') ? _c('v-radio-group', {
    staticClass: "py-0",
    attrs: {
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.addCountFiltros()
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Area en atención")])]
      },
      proxy: true
    }], null, false, 4264449154),
    model: {
      value: (_vm.tipoArea),
      callback: function($$v) {
        _vm.tipoArea = $$v
      },
      expression: "tipoArea"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "campo"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.tipoArea === 'campo'
          }
        }, [_vm._v("Campo")])]
      },
      proxy: true
    }], null, false, 631998500)
  }), _c('v-radio', {
    attrs: {
      "value": "taller"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.tipoArea === 'taller'
          }
        }, [_vm._v("Taller")])]
      },
      proxy: true
    }], null, false, 1509186308)
  }), _c('v-radio', {
    attrs: {
      "value": "sin asignacion"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.tipoArea === 'sin asignacion'
          }
        }, [_vm._v("Sin asignación")])]
      },
      proxy: true
    }], null, false, 2196436312)
  })], 1) : _vm._e(), (_vm.perfilUsuario !== 'usuario-contrato' && _vm.perfilUsuario !== 'usuario') ? _c('v-switch', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Ultima actividad por cliente"
    },
    on: {
      "change": function($event) {
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.isUltimaAccionCliente),
      callback: function($$v) {
        _vm.isUltimaAccionCliente = $$v
      },
      expression: "isUltimaAccionCliente"
    }
  }) : _vm._e(), _c('v-switch', {
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "label": "Cerrados"
    },
    on: {
      "change": function($event) {
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.isClosed),
      callback: function($$v) {
        _vm.isClosed = $$v
      },
      expression: "isClosed"
    }
  })], 1), (_vm.esCuentaAdministrador) ? _c('div', {
    staticClass: "flex-1 ml-6"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Cuentas relacionadas")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "info",
      "small": "small",
      "fab": "",
      "loading": _vm.isLoadingGetAccounts
    },
    on: {
      "click": function($event) {
        return _vm.fetchGetAccountsList()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")])], 1)], 1), _c('div', {
    staticClass: "d-flex mt-4 fd-column"
  }, _vm._l((_vm.cuentasRelacionadas), function(item, i) {
    return _c('div', {
      staticClass: "d-flex ai-center"
    }, [_c('v-checkbox', {
      staticClass: "ma-0",
      attrs: {
        "name": item.usuario,
        "id": item.usuario,
        "color": "primary",
        "hide-details": "hide-details"
      },
      model: {
        value: (item.active),
        callback: function($$v) {
          _vm.$set(item, "active", $$v)
        },
        expression: "item.active"
      }
    }), _c('label', {
      staticClass: "font-size-11",
      class: {
        '!primary--text font-weight-700': item.active
      },
      attrs: {
        "for": item.usuario
      }
    }, [_vm._v(_vm._s(item.razonSocial))])], 1)
  }), 0)]) : _vm._e()]), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "primary",
      "text": "text",
      "small": "small",
      "disabled": !_vm.countFiltros
    },
    on: {
      "click": function($event) {
        return _vm.limpiarFiltros()
      }
    }
  }, [_vm._v("Limpiar")]) : _vm._e(), _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "primary",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        _vm.fetch(), _vm.showFiltros = false
      }
    }
  }, [_vm._v("filtrar tickets")])], 1)], 1)], 1)], 1), _c('v-btn', {
    staticClass: "ma-3 mr-3",
    attrs: {
      "color": "primary",
      "small": "small",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.fetch()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")])], 1), (_vm.perfilUsuario !== 'usuario-contrato' && _vm.perfilUsuario !== 'usuario') ? _c('v-btn', {
    staticClass: "mt-3 mr-3",
    attrs: {
      "color": "success",
      "small": "small",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.openDialogExportar()
      }
    }
  }, [_c('v-icon', [_vm._v("import_export")])], 1) : _vm._e(), (!_vm.isMovil && (_vm.perfilUsuario === 'usuario' || _vm.perfilUsuario === 'usuario-contrato')) ? _c('v-btn', {
    staticClass: "mt-3 mr-3",
    attrs: {
      "color": "success",
      "fab": "fab",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchUsuario()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _c('v-snackbar', {
    attrs: {
      "absolute": "absolute",
      "top": "top",
      "color": "warning"
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var attrs = ref.attrs;

        return [(_vm.messageError.type === 'datos_incompletos') ? _c('v-btn', _vm._b({
          attrs: {
            "color": "white warning--text",
            "small": "small"
          },
          on: {
            "click": function($event) {
              return _vm.goTo('/profile')
            }
          }
        }, 'v-btn', attrs, false), [_vm._v("Ir a perfil")]) : _c('v-btn', _vm._b({
          attrs: {
            "color": "white warning--text",
            "small": "small"
          },
          on: {
            "click": function($event) {
              return _vm.closeModalErrorToCreateTicket()
            }
          }
        }, 'v-btn', attrs, false), [_vm._v("Entendido")])]
      }
    }]),
    model: {
      value: (_vm.isModalErrorToCreateTicket),
      callback: function($$v) {
        _vm.isModalErrorToCreateTicket = $$v
      },
      expression: "isModalErrorToCreateTicket"
    }
  }, [_vm._v(_vm._s(_vm.messageError.msg))])], 1), (!_vm.lista.length && _vm.isLoading) ? _c('div', {
    staticClass: "content-tickets-loading"
  }, _vm._l((15), function(a) {
    return _c('div', [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-skeleton-loader', {
      attrs: {
        "type": "list-item-avatar-two-line"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    })], 1), _c('v-skeleton-loader', {
      attrs: {
        "type": "divider"
      }
    })], 1)
  }), 0) : _vm._e(), _c('v-sheet', {
    staticClass: "overflow-y-auto",
    attrs: {
      "id": "data-tickets"
    }
  }, [_c('div', {
    class: {
      'content-tickets': _vm.lista.length
    }
  }, [_c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('ticket-summary-info', {
      key: index,
      staticClass: "animated fadeInUp faster",
      attrs: {
        "ticket": o
      },
      on: {
        "goTo": _vm.getTicketGoTo
      }
    })
  }), 1)]), (_vm.isMovil && (_vm.perfilUsuario === 'usuario' || _vm.perfilUsuario === 'usuario-contrato')) ? _c('v-btn', {
    staticClass: "floating-add",
    attrs: {
      "color": "success",
      "dark": "",
      "absolute": "",
      "large": "large",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.fetchUsuario()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1), (!_vm.lista.length && !_vm.isLoading) ? _c('div', {
    staticClass: "content-tickets d-flex jc-center ai-center"
  }, [(_vm.perfilUsuario === 'dispatcher' || _vm.perfilUsuario === 'recepcion') ? _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("format_list_bulleted")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No existen tickets para mostrar")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("No se encontro ningun ticket registrado")])], 1) : _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No existen tickets para mostrar")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("No se encontraron coincidencias para esta busqueda")])], 1)]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30dd1b12","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_tickets.vue
// module id = 491
// module chunks = 1